import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import services from './services.js';
//组件
import viewPhoto from 'src/common/js/viewPhoto';

//import address from 'agent-address';
//import agentSignMaterielv from 'agent-sign-materiel';
export default {
    mixins: [services],
    data() {
        return {
            loading: false,
            dialogVisible: false,
            id: 0,
            title: '',
            form: {},
            agentList: [{}],
            baseInfo: {},
            contact: {},
            examineData: this.getInitExamineData(), //审核提交数据
            AreaAduit: this.getAreaExamineData(), //区域审核数据
            isExamine: false, //是否是审核入口
            isAddBtnShow: [true],
            isDelBtnShow: [false],
            ListDoubtTypes: [{
                id: 1,
                value: '基本信息'
            }, {
                id: 2,
                value: '主联系人信息'
            }, {
                id: 3,
                value: '合作信息'
            }],
            isShowContact: true, //用来判断区域查看是否显示联系人信息和公司信息
            Corporation_Drawing: [], //法人身份证
            Company_Drawing: [], //营业执照
            agentInfo: this.getAgentInfo(),
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    watch: {

    },
    methods: {
        // 审核数据
        getInitExamineData() {
            return cloneDeep({
                TimeStamp: '',
                "CustomerId": 0,
                "AuditStatus": '',
                "AuditRemark": "",
                "ListDoubt": [{
                    "Module": "",
                    "ModuleName": ""
                }]
            });
        },
        // 区域审核
        getAreaExamineData() {
            return cloneDeep({
                "Id": 0,
                "AuditStatus": "",
                "AuditRemark": ""
            });
        },
        getAgentInfo() {
            return cloneDeep({
                Customer: '',
                AgentTel: '',
                Address: '',
                C_Name: ''
            });
        },
        initData() {
            this.title = ''
            this.form = {}
            this.agentList = [{}]
            this.baseInfo = {}
            this.contact = {}
            this.dialogVisible = true
            this.isShowContact = true
            this.isExamine = false
            this.examineData = this.getInitExamineData()
            this.agentInfo = this.getAgentInfo()
        },
        show(options) {
            this.initData()
            this.title = options.title
            if (options.Id && options.AgentAreaId == undefined) {
                // 意向代理商查看/审核

                this.GetById(options.Id)

            } else if (options.AgentAreaId !== undefined) {
                // 区域查看/审核
                this.AreaAduit.Id = options.AgentAreaId

                this.GetByCustomerAreaId(options.Id, options.AgentAreaId)
                this.agentInfo.Customer = options.msg.Customer
                this.agentInfo.C_Name = options.msg.CName
                this.agentInfo.AgentTel = options.msg.CTel
                this.agentInfo.Address = options.msg.AgentProvincesName + options.msg.AgentCityName + options.msg.AgentAreaName

            }
            if (options.isExamine) {
                // 审核
                this.isExamine = options.isExamine
                this.examineData.CustomerId = options.Id;

            }

        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "xxx", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: "xxx"
                }]
            });
        },
        removeList(index) {
            if (index !== -1) {
                this.examineData.ListDoubt.splice(index, 1)
                this.isAddBtnShow.shift(false)
                this.isDelBtnShow.pop(true)
            }
        },
        addList() {
            this.examineData.ListDoubt.push({
                "Module": "",
                "ModuleName": ""
            });
            this.isDelBtnShow.push(true); //删除按钮
            this.isAddBtnShow.unshift(false); //新增按钮
        },
        //关闭弹窗
        close() {

            this.dialogVisible = false;
        },

        submit() {
            this.$nextTick(() => {
                // 审核提交
                let flag = util.checkForm({
                    ele: this,
                    rules: [{
                        name: "审核意见",
                        value: this.examineData.AuditStatus,
                        required: true

                    }, {
                        name: "审核备注",
                        value: this.examineData.AuditRemark,
                        required: true
                    }]
                });
                if (!flag) {
                    return;
                }
                if (this.AreaAduit.Id > 0) {
                    // 区域审核
                    this.AreaAduit.AuditStatus = this.examineData.AuditStatus
                    this.AreaAduit.AuditRemark = this.examineData.AuditRemark
                    this.AgentAreaAudit(this.AreaAduit)
                } else {
                    let arr = []

                    for (let i = 0; i < this.examineData.ListDoubt.length; i++) {
                        if (this.examineData.ListDoubt[i].Module !== '') {
                            arr.push(this.examineData.ListDoubt[i].Module)
                        } else {
                            if (this.examineData.AuditStatus == 1) {
                                this.$notify({
                                    title: '警告',
                                    message: '请选择存疑模块！',
                                    type: 'warning'
                                });
                                return;
                            }

                        }

                    }
                    let arrSort = arr.sort()
                    for (var i = 0; i < arr.length; i++) {

                        if (arrSort[i] == arrSort[i + 1]) {
                            this.$notify({
                                title: '警告',
                                message: '存疑模块不能提交相同模块！',
                                type: 'warning'
                            });
                            return;
                        }
                    }
                    this.AgentAudit(this.examineData)
                }

            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/components/viewDialog/vm.js